import GamesSection from '@/pages/games/lobby/lobby-sections-streamlines/GamesSection';
import GamesSectionHeader from '@/pages/games/lobby/lobby-sections-streamlines/GamesSectionHeader';
import React, { useMemo } from 'react';
import GameProvidersDoubleStreamline from '@/components/shared/game-providers-streamline/GameProvidersDoubleStreamline';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { selectGameProviders } from '@/store/selectors/gamesSelectors';
import { useSelector } from 'react-redux';
import { thailandTopGameProvidersSlugs } from '@/constants/constants-thailand';

const TopGameProviders = () => {
  const navigate = useAbsoluteNavigate();
  const providers = useSelector(selectGameProviders(thailandTopGameProvidersSlugs));

  const visibleProviders = useMemo(() => {
    return providers.slice(0, Math.min(16, providers.length));
  }, [providers]);

  const cardClicked = (providerSlug: string) => {
    triggerGTag(GTagEvents.game_provider_card_clicked, {
      slug: `${providerSlug}/top-providers`,
    });
    navigate(`/games/provider/${providerSlug}`);
  };

  return (
    <GamesSection>
      <GamesSectionHeader
        title="ค่ายเกมฮิต"
        totalGames={providers.length}
        categoryPath="/games/providers"
      />
      <GameProvidersDoubleStreamline
        gameProviders={visibleProviders}
        slug="top"
        onClick={cardClicked}
      />
    </GamesSection>
  );
};

export default TopGameProviders;
